import Vue from 'vue'
import Router from 'vue-router'
// const Profile = () => import('@/components/User/Profile')
const Signup = () => import('@/components/User/Signup')
const Signin = () => import('@/components/User/Signin')
const Password = () => import('@/components/User/Password')
import UserList from '@/views/UserList'
import IssueRequest from '@/views/IssueRequest'
import IssueType from '@/views/IssueType'
import AuthGuard from './auth-guard'
import AuthGuardAdmin from './auth-guard-admin'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/password',
      name: 'Password',
      component: Password
    },
    {
      path: '/issue-request/:type',
      name: 'issuerequest',
      component: IssueRequest,
      beforeEnter: AuthGuard
    },
    {
      path: '/issue-type',
      name: 'issuetype',
      component: IssueType,
      beforeEnter: AuthGuard
    },
    {
      path: '/user-list',
      name: 'user-list',
      component: UserList,
      beforeEnter: AuthGuardAdmin
    },
    // {
    //   path: '/profile',
    //   name: 'Profile',
    //   component: Profile,
    //   beforeEnter: AuthGuard
    // },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js